import styled from "styled-components";

export const StyledReactSelectFieldContainer = styled.div`
  width: 100%;
  min-width: 0;
  margin-bottom: 22px;
  position: relative;
  z-index: 10;

  > :last-child {
    width: 100%;
    min-width: 0;
  }

  &.hide-label .caption-block-title {
    color: transparent;
  }
`;
